import { render, staticRenderFns } from "./ArticleLevel.vue?vue&type=template&id=aaab90f8&scoped=true"
import script from "./ArticleLevel.vue?vue&type=script&lang=js"
export * from "./ArticleLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaab90f8",
  null
  
)

export default component.exports